import React, { Component } from "react";

import { Button, Container, Grid, Icon, Menu } from "semantic-ui-react";
import {withCookies} from "react-cookie";
import "../styles/header.css";

class HeaderBar extends Component {
    state = {
        dropdownMenuStyle: {
            display: "none"
        }
    };

    constructor(props) {
        super(props);
        const {cookies} = props;
        this.state.csrfToken = cookies != null ? cookies.get('XSRF-TOKEN') : "cookies null so unavailable";
        this.logout = this.logout.bind(this);
    };

    handleToggleDropdownMenu = () => {
        let newState = Object.assign({}, this.state);
        if (newState.dropdownMenuStyle.display === "none") {
            newState.dropdownMenuStyle = { display: "flex" };
        } else {
            newState.dropdownMenuStyle = { display: "none" };
        }

        this.setState(newState);
    };

    logout() {
        const { reportUserSignedOut } = this.props;
        fetch('/api/logout', {method: 'POST', credentials: 'include',headers: {
                'X-XSRF-TOKEN': this.state.csrfToken}}
        ).then(res => res.json())
            .then(response => {
                reportUserSignedOut();
            });
    };

    render() {
        const {isAuthenticated} = this.props;
        const RenderLoginOrLogout = isAuthenticated ?
                (<Menu.Item href="/" className={"logOutButton"} onClick={this.logout}>
                    Log Out
                </Menu.Item>) :
                (<Menu.Item href="#root" className={"loginModalButton"}>
                    Log In
                </Menu.Item>);

        return (
            <>
                <Grid padded className="tablet computer only">
                    <Menu borderless fluid inverted size="huge">
                        <Container>
                            <Menu.Item header as="a" href="/">
                                Echo Banker
                            </Menu.Item>
                            <Menu.Item href="#root" className={"profileModalButton"}>
                                Profile
                            </Menu.Item>
                            <Menu.Item href="#root" className={"privacyModalButton"}>
                                Privacy
                            </Menu.Item>
                            <Menu.Item href="#root" className={"contactModalButton"}>
                                Contact
                            </Menu.Item>
                            <Menu.Item href="#root" className={"quickStartModalButton"}>
                                Quick Start
                            </Menu.Item>
                            <Menu.Item href="/accounts">
                                Accounts
                            </Menu.Item>
                            <Menu.Item href={"/institutions"}>
                                Institutions
                            </Menu.Item>
                            {RenderLoginOrLogout}
                        </Container>
                    </Menu>
                </Grid>
                <Grid padded className="mobile only">
                    <Menu borderless fluid inverted size="huge">
                        <Menu.Item header as="a" href="/">
                            Echo Banker
                        </Menu.Item>
                        <Menu.Menu position="right">
                            <Menu.Item>
                                <Button
                                    icon
                                    inverted
                                    basic
                                    toggle
                                    onClick={this.handleToggleDropdownMenu}>
                                    <Icon name="content" />
                                </Button>
                            </Menu.Item>
                        </Menu.Menu>
                        <Menu
                            borderless
                            fluid
                            inverted
                            vertical
                            style={this.state.dropdownMenuStyle}
                        >
                            <Menu.Item href="#root" className={"profileModalButton"}>
                                Profile
                            </Menu.Item>
                            <Menu.Item href="#root" className={"privacyModalButton"}>
                                Privacy
                            </Menu.Item>
                            <Menu.Item href="#root" className={"contactModalButton"}>
                                Contact
                            </Menu.Item>
                            <Menu.Item href="#root" className={"quickStartModalButton"}>
                                Quick Start
                            </Menu.Item>
                            <Menu.Item href="/accounts">
                                Accounts
                            </Menu.Item>
                            <Menu.Item href={"/institutions"}>
                                Institutions
                            </Menu.Item>
                            {RenderLoginOrLogout}
                        </Menu>
                    </Menu>
                </Grid>
            </>
        );
    }
}

/*
TODO: Add the propTypes for this component
HeaderBar.propTypes = {
    reportUserSignedOut: PropTypes.func.isRequired,

};
 */
export default withCookies(HeaderBar);